import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import useShallowEqualSelector from './components/core/useShallowEqualSelector';
import SplashScreen from './components/screens/SplashScreen';
import AppWrapper from './components/AppWrapper';
import StylesBuilder from './components-styles';
import * as allComps from './components/index';
import IframeCommunicator from './IframeCommunicator';
import { useApiDataHook } from './global-hooks';
import storageAndCookie from './global-utils/storage-and-cookies';
import { getIsAdminPreview } from './shared/admin-preview';
import { HoldingPageGuard } from './modules/holding-page';
import { stripOrigin } from './shared/misc';
import { SignalRProvider } from './modules/signal-r';
import { CoreComponents } from './features/core-components';
import ScreenSaverWrapper from './modules/terminal/ui/ScreenSaverWrapper';
import { UserBoot } from './modules/user-boot';

const FullApp = () => {
  const { splashScreen, globalApiCalls = {} } = useShallowEqualSelector(
    (state) => state.appState.settings
  );
  const { currentBreakpoint } = useShallowEqualSelector((state) => state.appState);
  const [isSplash, setIsSplash] = useState(false);
  // At the moment intentionally, we do not rerender FullApp based on urlParams and
  // urlSearchParams (we do not pass these args to useApiDataHook).
  // For the moment, assumption is that globalApiCalls are supposed to be static.
  // @isActive ?/: - hooks cannot be rendered conditionally so to prevent API calls
  //   we pass empty array
  const apiDataGlobal = useApiDataHook(globalApiCalls.isActive ? globalApiCalls.apiDataInfo : []);
  window.pag_initialized = false; // Reset pag_initialized to false
  useEffect(() => {
    if (splashScreen) {
      const {
        isActive, durationInMs, limitToTimes, forceClose, hideWhen = []
      } = splashScreen;
      let showSplash = !!isActive;
      if (limitToTimes) {
        const totalShowed = Number.parseInt(storageAndCookie.get('splashScreenShowCount') || 0, 10);
        if (limitToTimes <= totalShowed) {
          showSplash = false;
        } else {
          storageAndCookie.set('splashScreenShowCount', totalShowed + 1);
        }
      }
      if (showSplash) {
        const timeout = Number(durationInMs) || 3000;
        setIsSplash(true);
        setTimeout(() => {
          setIsSplash(false);
        }, timeout);
      }
      const ifShouldHide = () => hideWhen?.some((el) => el === currentBreakpoint);
      if (forceClose || ifShouldHide()) setIsSplash(false);
    }
  }, [splashScreen]);

  return (
    <>
      {getIsAdminPreview() && <IframeCommunicator />}
      <StylesBuilder apiData={apiDataGlobal} />
      <BrowserRouter>
        <CoreComponents apiData={apiDataGlobal} />
        {isSplash && <SplashScreen {...splashScreen} allComps={allComps} apiData={apiDataGlobal} />}
        {!isSplash && (
          <HoldingPageGuard
            url={stripOrigin(window.location.href)}
            allComps={allComps}
            apiData={apiDataGlobal}
          >
            <ScreenSaverWrapper>
              <SignalRProvider>
                <UserBoot allComps={allComps} >
                  <AppWrapper allComps={allComps} apiData={apiDataGlobal} />
                </UserBoot>
              </SignalRProvider>
            </ScreenSaverWrapper>
          </HoldingPageGuard>
        )}
      </BrowserRouter>
    </>
  );
};

export default FullApp;
